import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {

    constructor(private http: HttpClient) {

    }

    //add all type of user in database
    add(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/user/add`, data)
            .pipe(
                map(res => res)
            )
    }

    updaterots(data: any): Observable<any> {
        return this.http.put<any>(`${environment.baseUrl}/analytics/updaterots`, data)
        .pipe(
            map( res => res)
        );
    }
    updateallrots(data: any): Observable<any> {
        return this.http.put<any>(`${environment.baseUrl}/analytics/updateallrots`, data)
        .pipe(
            map( res => res)
        );
    }
    closeRos(data: any): Observable<any> {
        return this.http.put<any>(`${environment.baseUrl}/analytics/closeRos`, data)
        .pipe(
            map( res => res)
        );
    }
    //update user
    update(data): Observable<any> {
        return this.http.put<any>(`${environment.baseUrl}/user`, data)
            .pipe(
                map(res => res)
            )
    }

    // get user by id
    getByUserId(userId): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}/user/${userId}`)
            .pipe(
                map(res => res)
            )
    }
    // get report by name
    getByReportName(name): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}/report/${name}`)
            .pipe(
                map(res => res)
            )
    }
    //get all users by filters
    getAllUsers(filters: any): Observable<any> {
        console.log("in user service   :", filters);
        return this.http.post<any>(`${environment.baseUrl}/users`, filters)
            .pipe(
                map(res => res)
            )
    }

    getRosExport(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/ros-attachment-excel`,data, {responseType:'blob' as 'json'})
        .pipe(
            map( res => res)
        );
    }
    getAllreturnofthespares(filters: any): Observable<any> {
        console.log("in user service   :", filters);
        return this.http.post<any>(`${environment.baseUrl}/allreturnofthespares`, filters)
            .pipe(
                map(res => res)
            )
    }  
    getAllWHUser(filters: any): Observable<any> {
        console.log("in user service   :", filters);
        return this.http.post<any>(`${environment.baseUrl}/whuser`, filters)
            .pipe(
                map(res => res)
            )
    }
    getAllUsersDataWithPage(filters: any): Observable<any> {
        console.log("in user service   :", filters);
        return this.http.post<any>(`${environment.baseUrl}/users_without_offset`, filters)
            .pipe(
                map(res => res)
            )
    }

    getAllRSMUsers(filters: any): Observable<any> {
        console.log("-------in user service getAllRSMUsers   :", filters);
        return this.http.post<any>(`${environment.baseUrl}/rsm-users`, filters)
            .pipe(
                map(res => res)
            )
    }

    getAllBoAsmIspUsers(filters: any): Observable<any> {
        console.log("-------in user service getAllBOUsers   :", filters);
        return this.http.post<any>(`${environment.baseUrl}/bo-asm-isp-users`, filters)
            .pipe(
                map(res => res)
            )
    }

    // get all isp
    getAllIsp(): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}/isps`)
            .pipe(
                map(res => res)
            )
    }
    getAllRsm(): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}/rsm`)
            .pipe(
                map(res => res)
            )
    }
    // get login user isps
    getLoginUserIsp(): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}/login-isps`)
            .pipe(
                map(res => res)
            )
    }

    //decativate User
    deactivateUser(data): Observable<any> {
        return this.http.put<any>(`${environment.baseUrl}/user-delete`, data)
            .pipe(
                map(res => res)
            )
    }

    //reset Password
    resetPassword(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/reset-password`, data)
            .pipe(
                map(res => res)
            )
    }
    getAllIsps(filter: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/admin/isp`, filter)
            .pipe(
                map(res => res)
            );
    }
    //get all isp stat
    getAllIspStatistics(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/analytics/isp`, data)
            .pipe(
                map(res => res)
            )
    }
    //get all report stat
    getAllReportdata(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/analytics/report`, data)
            .pipe(
                map(res => res)
            )
    }

    getAllIspStatisticswithoutfilter(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/analytics/isp/getAllIspStatisticswithoutfilter`, data)
            .pipe(
                map(res => res)
            )
    }
    //get all isp stat
    getAllIspStatisticsispexcel(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/analytics/isp-excel`, data, { responseType: 'blob' as 'json' })
            .pipe(
                map(res => res)
            )
    }
    getmisOrderExport(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/analytics/technicians-excel`, data, { responseType: 'blob' as 'json' })
            .pipe(
                map(res => res)
            );
    }
    //get all isp stat
    getAllTechStatisticsForIsp(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/analytics/technicians`, data)
            .pipe(
                map(res => res)
            )
    }

    //get all isp stat
    getAllTechStatisticsForAdmin(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/analytics/ad-technicians`, data)
            .pipe(
                map(res => res)
            )
    }

    //get all ReportList
    getAllReportlist() {
        return this.http.get<any>(`${environment.baseUrl}/reports`)
            .pipe(
                map(res => res)
            )
    }
    getspare() {
        return this.http.get<any>(`${environment.baseUrl}/spare`)
            .pipe(
                map(res => res)
            )
    }
    getsparesearch(filters: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/sparesearch`, filters)
            .pipe(
                map(((res) => res.data))
            );
    }
    getUniqueScds() {
        return this.http.get<any>(`${environment.baseUrl}/scd`)
            .pipe(
                map(res => res)
            )
    }
    getallIsp(filters: any) {
        console.log("in user service111   :", filters);
        return this.http.post<any>(`${environment.baseUrl}/isps-login-based`, filters)
            .pipe(
                map(res => res)
            )
    }

    getAllIspsonsearch(filters: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/isps`, filters)
            .pipe(
                map(((res) => res.data))
            );
    }

    getUniquePcds() {
        return this.http.get<any>(`${environment.baseUrl}/pcd`)
            .pipe(
                map(res => res)
            )
    }
    getRcdsOfScd(scd) {
        return this.http.get<any>(`${environment.baseUrl}/rcd/${scd}`)
            .pipe(
                map(res => res)
            )
    }
    getRcdsforrsm(scd) {
        return this.http.get<any>(`${environment.baseUrl}/rsm-rcd/${scd}`)
            .pipe(
                map(res => res)
            )
    }
    getISPsOfRcd(rcd) {
        return this.http.get<any>(`${environment.baseUrl}/city-isp/${rcd}`)
            .pipe(
                map(res => res)
            )
    }

    getISPsOfSCD(scd) {
        return this.http.get<any>(`${environment.baseUrl}/state-isp/${scd}`)
            .pipe(
                map(res => res)
            )
    }

    getIspFromBranch(scd) {
        return this.http.get<any>(`${environment.baseUrl}/isps/${scd}`)
            .pipe(
                map(res => res)
            )
    }


    getAllTechniciansForIsp(data): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/analytics/technicians-by-isp`, data)
            .pipe(
                map(res => res)
            )
    }

    getTechnicianDetails(userId): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}/details/${userId}`)
            .pipe(
                map(res => res)
            )
    }

    returnofthespares(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/user/returnofthespares`, data)
        .pipe(
            map( res => res)
        );
    }

    uploadUserExcel(file: FormData): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/user-uploadfile`, file,{ observe: 'response' })
           
    }
    getUploadedUser(data: any): Observable<any> {
        return this.http.post<any>(`${environment.baseUrl}/uploaded-user`,data, {responseType:'blob' as 'json'})
        .pipe(
            map( res => res)
        );
    }
    
    // search(data :any,req?: any) {
    //     const options = createRequestOption(req);
    //     return this.http
    //       .post<IMaterial[]>(this.resourceUrl + '/get', data, { params: options, observe: 'response' })
    //       .pipe(map((res: EntityArrayResponseType) => res.body));
    //   }



    // getTechnicianImage(userId): Observable<any> {
    //     return this.http.get<any>(`${environment.baseUrl}/technician-image/${userId}`, {responseType:'blob' as 'json'})
    //     .pipe(
    //         map( res => res)
    //     )
    // }

}